import { render, staticRenderFns } from "./AccessPointsModal.vue?vue&type=template&id=483cc336&"
import script from "./AccessPointsModal.vue?vue&type=script&lang=js&"
export * from "./AccessPointsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports